export default (state = null, action) => {
  const { type, payload } = action
  switch (type) {
    case 'SET_APP_MESSAGE':
      return payload
    case 'CLEAR_APP_MESSAGE':
      return null
    case 'LOGOUT':
      return null
    default:
      return state
  }
}
